module.exports = __webpack_public_path__ + "img/DiaryBarham-Rastgoiy.46851fed.jpg";